export const GET_FORMAT_REQUEST = 'GET_FORMAT_REQUEST';
export const GET_FORMAT_SUCCESS = 'GET_FORMAT_SUCCESS';
export const GET_FORMAT_FAILED = 'GET_FORMAT_FAILED';

export const LOAD_UPDATE_REQUEST = 'LOAD_UPDATE_REQUEST';
export const LOAD_UPDATE_SUCCESS = 'LOAD_UPDATE_SUCCESS';
export const LOAD_UPDATE_FAILED = 'LOAD_UPDATE_FAILED';

export const LOAD_IMPORT_REQUEST = 'LOAD_IMPORT_REQUEST';
export const LOAD_IMPORT_SUCCESS = 'LOAD_IMPORT_SUCCESS';
export const LOAD_IMPORT_FAILED = 'LOAD_IMPORT_FAILED';
